// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../../../images/video-processing.svg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var code = "<div class=\"processing-video\"> <div class=\"processing-video-contents\"> <span class=\"video-processing-spinner-container\"> <img src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\" class=\"video-processing-spinner\"> </span> <span class=\"video-processing-text\"> Processing Video... </span> </div> </div> ";
// Exports
module.exports = code;